module.exports = __webpack_public_path__ + "static/media/bulma.b5485f31.png";